<template>
  <a-card :bordered="false">
    <div class="bonus-manage">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="13" :lg="11" :md="12" :sm="13">
              <a-form-item label="产品代码/名称">
                <a-select
                  v-model="queryParam.fundCode"
                  show-search
                  placeholder="请选择产品代码/名称"
                  style="width: 400px"
                  optionFilterProp="label"
                >
                  <a-select-option
                    v-for="item in fundList"
                    :key="item.fundCode"
                    :label="item.fundCodeName"
                  >
                    {{ item.fundCodeName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :xl="10" :lg="7" :md="8">
              <span
                style="float: left; overflow: hidden"
                class="table-page-search-submitButtons"
              >
                <a-button type="primary" @click="searchQuery" icon="search"
                  >查询</a-button
                >
                <a-button
                  type="primary"
                  @click="searchReset"
                  icon="reload"
                  style="margin-left:8px"
                  >重置</a-button
                >
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 查询区域-END -->

      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel"
              ><a-icon type="delete" />批量删除</a-menu-item
            >
          </a-menu>
          <a-button> 批量操作 <a-icon type="down"/></a-button>
        </a-dropdown>
      </div>
      <div>
        <!-- 清空 -->
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
          <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
          >项
          <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        </div>
        <a-table
          ref="tableSelect"
          :columns="columns"
          rowKey="id"
          bordered
          :data-source="dataSource"
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange
          }"
          :pagination="ipagination"
          class="j-table-force-nowrap"
          @change="handleTableChange"
        >
          <span slot="action" slot-scope="text, record">
            <a @click="handleEdit(record)">编辑 </a>
            <a-divider type="vertical" />
            <a @click="handleDelete(record)">删除 </a>
          </span>
          <template slot="rate_type" slot-scope="text, record">
            <span v-for="(item, index) in rate_type" :key="index">
              <span v-if="record.rateType === item.value">
                {{ item.text }}
              </span>
            </span>
          </template>
          <template slot="fee_type" slot-scope="text">
            <span v-for="(item, index) in fee_type" :key="index">
              <span v-if="text === item.value">
                {{ item.text }}
              </span>
            </span>
          </template>
        </a-table>
      </div>

      <rate-manage-modal
        :fundList="fundList"
        :rate_type="rate_type"
        :fee_type="fee_type"
        ref="modalForm"
        @ok="modalFormOk"
      ></rate-manage-modal>
    </div>
  </a-card>
</template>
<script>
import '@/assets/less/TableExpand.less';
import { mixinDevice } from '@/utils/mixin';
import rateManageModal from './add.vue';
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue';
import { getAction, postAction, postTag } from '@/api/manage.js';
import { filterObj } from '@/utils/util';
import { getRateList } from '@/api/product.js';

const columns = [
  {
    title: '产品代码',
    dataIndex: 'fundCode',
    key: 'name',
    align: 'center'
  },
  {
    title: '产品名称',
    dataIndex: 'fundName',
    align: 'center'
  },
  {
    title: '费率类型',
    dataIndex: 'rateType_dictText',
    align: 'center'
  },
  {
    title: '收费方式',
    dataIndex: 'feeType_dictText',
    align: 'center',
    customRender: text => {
      return !text || text == '' ? '--' : text;
    }
  },
  {
    title: '计算方式',
    dataIndex: 'intervalType',
    align: 'center',
    customRender: text => {
      return text == 1 ? '固定型' : text == 2 ? '范围型' : '说明型';
    }
  },

  {
    title: '操作',
    dataIndex: '',
    key: 'x',
    align: 'center',
    scopedSlots: { customRender: 'action' }
  }
];

export default {
  name: 'BonusManage',
  mixins: [mixinDevice],
  components: {
    JDictSelectTag,
    rateManageModal
  },

  data() {
    return {
      showDialog: false,
      fundCode: '',
      pageSize: 10,
      current: 1,
      confirmLoading: false,
      columns,
      selectedRowKeys: [],
      selectionRows: [],
      dataSource: [],
      rate_type: [],
      fee_type: [],
      fundList: [],
      superQueryParams: '',
      queryParam: {
        fundName: ''
      },
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      url: {
        list: process.env.VUE_APP_CMS_PRODUCT + '/product/rate/list',
        delete: process.env.VUE_APP_CMS_PRODUCT + '/product/rate/delete',
        deleteBatch:
          process.env.VUE_APP_CMS_PRODUCT + '/product/rate/deleteBatch',
        exportXlsUrl:
          process.env.VUE_APP_CMS_PRODUCT +
          '/admin/product/productsFundRate/exportXls',
        importExcelUrl:
          process.env.VUE_APP_CMS_PRODUCT +
          '/admin/product/productsFundRate/importExcel',
        productUrl:
          process.env.VUE_APP_CMS_PRODUCT + '/product/fund/list/reviewed/all'
      }
    };
  },
  created() {
    this.getList();
    this.initData();
    this.productName();
  },
  methods: {
    initData() {
      getAction(
        process.env.VUE_APP_CMS_SYSTEM + `/sys/dict/getDictItems/rate_type`,
        {}
      ).then(res => {
        if (res.success) {
          this.rate_type = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    productName() {
      getAction(this.url.productUrl).then(res => {
        if (res.success) {
          res.result.map(item => {
            item.fundCodeName = item.fundName + '/' + item.fundCode;
          });
          this.fundList = res.result ? res.result : [];
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    upload() {
      this.showDialog = false;
    },
    // 查询
    getList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = {
        pageNo: that.ipagination.current,
        pageSize: that.ipagination.pageSize
      }; //this.getQueryParams();

      if (that.queryParam.fundCode != '') {
        params.fundCode = that.queryParam.fundCode;
      }

      that.loading = true;
      getRateList(params).then(res => {
        that.loading = false;
        if (res.success) {
          that.dataSource =
            res.result && res.result.records ? res.result.records : [];
          that.ipagination.total =
            res.result && res.result.total ? res.result.total : 0;
        } else {
          that.$message.error(res.message);
        }
      });
    },
    //获取点中的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    //添加
    handleAdd() {
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = '新增';
      this.$refs.modalForm.disableSubmit = false;
    },
    //获取查询条件
    getQueryParams() {
      let sqp = {};
      let param = Object.assign(sqp, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    // 编辑
    handleEdit(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '修改';
      this.$refs.modalForm.disableSubmit = false;
    },
    getQueryField() {
      var str = 'id,';
      this.columns.forEach(function(value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },
    //批量删除
    batchDel() {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function() {
            that.loading = true;
            postAction(that.url.deleteBatch, { ids: ids })
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.getList();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          }
        });
      }
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.getList();
    },
    //删除
    handleDelete(record) {
      let that = this;
      that.$confirm({
        title: '确认删除',
        content: '确定要删除吗',
        onOk: function() {
          that.loading = true;
          let formdata = new FormData();
          formdata.append('id', record.id);
          formdata.append('fundCode', record.fundCode);
          postTag(that.url.delete, formdata).then(res => {
            that.loading = false;
            if (res.success) {
              that.getList(1);
              that.$message.success(res.message);
            } else {
              that.$message.error(res.message);
            }
          });
        }
      });
    },
    //查询
    searchQuery() {
      this.getList(1);
    },
    //重置
    searchReset() {
      this.queryParam = {};
      if (this.$route.query.type != 4) {
        this.getList(1);
      }
    },
    //清空选中数据
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.getList();
    }
  }
};
</script>
<style lang="less" scoped>
.bonus-manage {
  background: #fff;
  // padding: 25px;

  .table-operator {
    margin-bottom: 8px;
    .ant-btn {
      margin: 0 8px 8px 0;
    }
  }

  .bonus-header {
    .mg {
      margin: 20px 0;
    }
    button {
      margin-right: 10px;
    }
    .select-container {
      span {
        margin-right: 15px;
      }
    }
  }
}
</style>
